import React from "react";
import Select from "react-select";

function Select2({
  data = [],
  value,
  onChange,
  options = {},
  multiple,
  onOpen,
  style,
  ...rest
}) {
  const isMulti = multiple ?? options.isMulti ?? options.closeOnSelect === false;
  const optionList = Array.isArray(data) ? data : [];

  const selectedValue = isMulti
    ? optionList.filter((item) => {
        const currentValues = Array.isArray(value) ? value : value == null ? [] : [value];
        return currentValues.some((current) => String(current) === String(item.id));
      })
    : optionList.find((item) => String(item.id) === String(value)) ?? null;

  const handleChange = (selected) => {
    if (typeof onChange !== "function") return;

    if (isMulti) {
      const selectedIds = Array.isArray(selected) ? selected.map((item) => item.id) : [];
      onChange({
        target: {
          value: selectedIds,
          multiple: true,
        },
      });
      return;
    }

    onChange({
      target: {
        value: selected ? selected.id : "",
        multiple: false,
      },
    });
  };

  const formatOptionLabel = (option) => (
    <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      {option.image ? (
        <img
          src={option.image}
          alt=""
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            objectFit: "cover",
            flex: "0 0 auto",
          }}
        />
      ) : null}
      <span>{option.text ?? option.label ?? String(option.id ?? "")}</span>
    </span>
  );

  return (
    <div style={style}>
      <Select
        {...rest}
        inputId={rest.id}
        instanceId={rest.id}
        isMulti={isMulti}
        isClearable={options.allowClear ?? true}
        closeMenuOnSelect={options.closeOnSelect ?? !isMulti}
        placeholder={options.placeholder}
        onMenuOpen={onOpen}
        value={selectedValue}
        onChange={handleChange}
        options={optionList}
        getOptionValue={(option) => String(option.id)}
        getOptionLabel={(option) => option.text ?? option.label ?? String(option.id ?? "")}
        formatOptionLabel={formatOptionLabel}
        styles={{
          container: (base) => ({
            ...base,
            width: "100%",
          }),
          ...options.styles,
        }}
      />
    </div>
  );
}

export default Select2;
